import { type LogLevel } from './utils/logger';

const env = import.meta.env;

export const ENV = {
  NODE_ENV: env.MODE,
  BACKEND_API_DOMAIN: env.PG_BACKEND_API_DOMAIN,
  OKTA_ISSUER: env.PG_FRONTEND_OKTA_ISSUER,
  OKTA_CLIENT_ID: env.PG_FRONTEND_OKTA_CLIENT_ID,
  LOG_LEVEL: (env.PG_FRONTEND_LOG_LEVEL || 'info') as LogLevel,
} as const;

// Validate required environment variables with correct prefixes
const requiredVars = [
  { name: 'PG_BACKEND_API_DOMAIN', value: ENV.BACKEND_API_DOMAIN },
  { name: 'PG_FRONTEND_OKTA_ISSUER', value: ENV.OKTA_ISSUER },
  { name: 'PG_FRONTEND_OKTA_CLIENT_ID', value: ENV.OKTA_CLIENT_ID },
] as const;

for (const { name, value } of requiredVars) {
  if (!value) {
    throw new Error(`Missing required environment variable: ${name}`);
  }
}
